<template>
  <div class="animated fadeIn">
    <div v-if="loading" class="loading-container">
      <RotateSquare
        class="loading-position animated fadeIn"
        size="60px"
      ></RotateSquare>
    </div>
    <form v-else @submit="ValidarForm">
      <div class="row">
        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <div class="card">
            <header class="card-header no-print">
              <strong class="align-self-center">Inventário Florestal</strong>
            </header>
            <div class="card-body">
              <div class="row no-print">
                <div class="col">
                  <div class="form-group">
                    <small>Campos com * são de preenchimento obrigatório</small>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>* Projeto</label>
                    <input
                      v-if="isEdit"
                      readonly
                      v-model="project.name"
                      class="form-control"
                    />
                    <v-select
                      v-else
                      placeholder="Digite o nome do projeto"
                      v-model="project"
                      :options="projects"
                      v-on:input="OnChangeProject"
                      readonly
                      required
                    >
                      <template slot="no-options">
                        Nenhum resultado para a busca.
                      </template>
                    </v-select>
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>* Data </label>
                    <input
                      v-model="viewModel.date"
                      class="form-control"
                      type="date"
                      placeholder="Digite a data"
                      required
                    />
                  </div>
                </div>
              </div>
              <GoogleMaps
                setLocalEmit="set-location"
                @set-location="SetLocation"
                :markers="markers"
              />
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Id</label>
                    <input
                      v-model="viewModel.sequence"
                      class="form-control"
                      type="number"
                      placeholder="Digite o id"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Nome Comum</label>
                    <input
                      v-model="viewModel.commonName"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome comum"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Nome Científico</label>
                    <input
                      v-model="viewModel.scientificName"
                      class="form-control"
                      type="text"
                      placeholder="Digite o nome científico"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Origem</label>
                    <b-form-radio
                      v-model="viewModel.origin"
                      name="origin-radio"
                      value="Nativa"
                      >Nativa</b-form-radio
                    >
                    <b-form-radio
                      v-model="viewModel.origin"
                      name="origin-radio"
                      value="Exótica"
                      >Exótica</b-form-radio
                    >
                    <b-form-radio
                      v-model="viewModel.origin"
                      name="origin-radio"
                      value="Exótica Invasora"
                      >Exótica Invasora</b-form-radio
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Família</label>
                    <input
                      v-model="viewModel.family"
                      class="form-control"
                      type="text"
                      placeholder="Digite a família"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Altura total (Ht) m</label>
                    <input
                      v-model="viewModel.heigth"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite a altura"
                    />
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>Classe de altura observado a campo</label>
                    <b-form-radio
                      v-model="viewModel.heigthClass"
                      name="heigthClass-radio"
                      value="Pequeno (< 6m)"
                      >Pequeno (< 6m)</b-form-radio
                    >
                    <b-form-radio
                      v-model="viewModel.heigthClass"
                      name="heigthClass-radio"
                      value="Médio (6 a 12m)"
                      >Médio (6 a 12m)</b-form-radio
                    >
                    <b-form-radio
                      v-model="viewModel.heigthClass"
                      name="heigthClass-radio"
                      value="Grande (> 12m)"
                      >Grande (> 12m)</b-form-radio
                    >
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>CAP (cm)</label>
                    <input
                      v-model="viewModel.cap"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite o CAP"
                      @change="OnChangeCap"
                    />
                  </div>
                </div>
                <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3">
                  <div class="form-group">
                    <label for>DAP (cm)</label>
                    <input
                      v-model="viewModel.dap"
                      class="form-control"
                      type="number"
                      step="0.01"
                      placeholder="Digite o DAP"
                      @change="OnChangeDap"
                    />
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col">
                  <div class="form-group">
                    <label for="">Observações</label>
                    <b-form-textarea
                      v-model="viewModel.obs"
                      rows="4"
                      max-rows="12"
                      placeholder="Digite observações"
                    ></b-form-textarea>
                  </div>
                </div>
              </div>
              <div class="row no-print">
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                    <label for>Imagens </label> <small>Limite 20MB</small>
                    <b-form-file
                      v-model="files"
                      :state="Boolean(files)"
                      placeholder="Escolha o(s) arquivo(s)..."
                      accept=".jpg, .png, .jpeg"
                      browse-text="Procurar"
                      multiple
                    ></b-form-file>
                  </div>
                </div>
              </div>
              <GalleryImage
                removeEmit="remove-file"
                @remove-file="RemoveFile"
                :images="images"
              />

              <div v-if="dynamicAnswers.length > 0" class="row mt-3">
                <div class="col-12">
                  <hr />
                  <strong>Perguntas Dinâmicas</strong>
                </div>
                <div
                  v-for="resposta in dynamicAnswers"
                  :key="resposta.dynamicQuestionId"
                  class="col-sm-12 col-md-6 col-lg-4 mt-3"
                >
                  <div class="form-group">
                    <label>
                      {{ resposta.isRequired ? "* " : "" }}{{ resposta.questionTitle }}
                    </label>
                    <!-- Texto Curto -->
                    <input
                      v-if="resposta.questionType === QuestionTypeEnum.ShortText"
                      v-model="resposta.textValue"
                      class="form-control"
                      type="text"
                      :required="resposta.isRequired"
                    />
                    <!-- Texto Longo -->
                    <b-form-textarea
                      v-else-if="resposta.questionType === QuestionTypeEnum.LongText"
                      v-model="resposta.textValue"
                      rows="3"
                      :required="resposta.isRequired"
                    />
                    <!-- Escolha Única -->
                    <div v-else-if="resposta.questionType === QuestionTypeEnum.SingleChoice">
                      <b-form-radio
                        v-for="opt in resposta.options"
                        :key="opt.id"
                        v-model="resposta._selectedSingle"
                        :value="opt.id"
                        :name="'radio-' + resposta.dynamicQuestionId"
                      >{{ opt.label }}</b-form-radio>
                    </div>
                    <!-- Múltipla Escolha -->
                    <div v-else-if="resposta.questionType === QuestionTypeEnum.MultipleChoice">
                      <b-form-checkbox
                        v-for="opt in resposta.options"
                        :key="opt.id"
                        v-model="resposta.selectedOptionIds"
                        :value="opt.id"
                      >{{ opt.label }}</b-form-checkbox>
                    </div>
                    <!-- Lista Suspensa -->
                    <b-form-select
                      v-else-if="resposta.questionType === QuestionTypeEnum.Dropdown"
                      v-model="resposta._selectedSingle"
                      :options="resposta.options.map((o) => ({ value: o.id, text: o.label }))"
                    />
                    <!-- Escala -->
                    <div v-else-if="resposta.questionType === QuestionTypeEnum.Scale">
                      <input
                        v-model="resposta.textValue"
                        class="form-control-range"
                        type="range"
                        min="1"
                        max="10"
                        :required="resposta.isRequired"
                      />
                      <small class="text-muted">Valor: {{ resposta.textValue || 1 }}</small>
                    </div>
                    <!-- Data -->
                    <input
                      v-else-if="resposta.questionType === QuestionTypeEnum.Date"
                      v-model="resposta.textValue"
                      class="form-control"
                      type="date"
                      :required="resposta.isRequired"
                    />
                    <!-- Número -->
                    <input
                      v-else-if="resposta.questionType === QuestionTypeEnum.Number"
                      v-model="resposta.textValue"
                      class="form-control"
                      type="number"
                      step="any"
                      :required="resposta.isRequired"
                    />
                    <!-- E-mail -->
                    <input
                      v-else-if="resposta.questionType === QuestionTypeEnum.Email"
                      v-model="resposta.textValue"
                      class="form-control"
                      type="email"
                      :required="resposta.isRequired"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="btn-toolbar mb-3 ml-3 no-print" role="toolbar">
              <div class="btn-group" role="group">
                <button class="btn btn-success mr-2" type="submit">
                  Salvar
                </button>
              </div>
              <div class="btn-group mr-2" role="group">
                <button
                  class="btn btn-secondary"
                  type="reset"
                  @click="$router.go(-1)"
                >
                  Voltar
                </button>
              </div>
              <div class="btn-group" role="group">
                <b-button variant="outline-dark" @click="Print"
                  >Imprimir</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import RotateSquare from "../../components/RotateSquare";
import InventoryService from "../../servico/InventoryService";
import DateTime from "../../util/DateTime";
import GoogleMaps from "../../components/GoogleMaps";
import ProjectService from "../../servico/ProjectService";
import FileService from "../../servico/ArquivoServico";
import GalleryImage from "../../components/GalleryImage.vue";
import DynamicFormService from "../../servico/DynamicFormService";
import QuestionTypeEnum from "../../enums/QuestionTypeEnum";

export default {
  name: "NewInventory",
  components: {
    RotateSquare,
    GoogleMaps,
    GalleryImage
  },
  data() {
    return {
      QuestionTypeEnum,
      isEdit: false,
      loading: false,
      dynamicAnswers: [],
      projects: [],
      files: null,
      images: null,
      project: {},
      markers: [],
      viewModel: {
        id: this.$store.getters.emptyGuid,
        projectId: null,
        date: DateTime.Now(),
        dap: null,
        cap: null,
        obs: "",
        heigthClass: "",
        heigth: "",
        family: "",
        origin: "",
        scientificName: "",
        commonName: "",
        latitude: null,
        longitude: null,
        sequence: 0,
        files: []
      }
    };
  },
  mounted() {
    let id = this.$route.params.id;
    if (id && id !== this.$store.getters.emptyGuid) {
      this.isEdit = true;
      this.Get(id);
      this.GetFiles(id);
      this.GetDynamicAnswers(id);
    } else {
      this.GetDynamicQuestions();
    }
    this.OnSearchProjects("   ");
  },
  methods: {
    Print() {
      window.print();
    },
    OnChangeProject(a) {
      if (this.isEdit) return;
      if (!this.project) return;

      ProjectService.GetCoordinates(this.project.id)
        .then((result) => {
          this.markers = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });

      ProjectService.GetNextSequence(this.project.id)
        .then((result) => {
          this.viewModel.sequence = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    OnChangeCap() {
      this.viewModel.dap = (this.viewModel.cap / 3.14).toFixed(2);
    },
    OnChangeDap() {
      this.viewModel.cap = (this.viewModel.dap * 3.14).toFixed(2);
    },
    ValidarForm(evt) {
      evt.preventDefault();
      this.Save();
    },
    OnSearchProjects(term) {
      if (!term || term.length <= 2) return;

      ProjectService.GetVSelect(term, false)
        .then((result) => {
          this.projects = result.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    RemoveFile(item) {
      InventoryService.RemoveFile(item.id, this.viewModel.id)
        .then((resposta) => {
          this.loading = false;
          this.images.splice(this.images.indexOf(item), 1);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    Get(id) {
      this.loading = true;

      InventoryService.Get(id)
        .then((resposta) => {
          this.loading = false;
          this.viewModel = resposta.data;
          this.viewModel.date = DateTime.Format(resposta.data.date);
          this.markers.push({
            lat: this.viewModel.latitude,
            lng: this.viewModel.longitude,
            label: "NOVO",
            new: true,
            result: 0
          });
          this.GetProject(this.viewModel.projectId);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetProject(id) {
      ProjectService.Get(id)
        .then((resposta) => {
          this.project = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetFiles(inventoryId) {
      InventoryService.GetFiles(inventoryId)
        .then((resposta) => {
          this.images = resposta.data;
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    UploadFiles() {
      this.loading = true;
      FileService.New(this.files)
        .then((response) => {
          this.loading = false;
          this.viewModel.files = response.data;
          if (this.isEdit) this.SaveEdit();
          else this.SaveNew();
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    SaveEdit() {
      this.loading = true;

      InventoryService.Edit(this.viewModel)
        .then(() => {
          this.loading = false;
          this.$notify({
            data: ["Inventário editado com sucesso."],
            type: "success",
            duration: 5000
          });
          if (this.dynamicAnswers.length > 0) {
            this.SalvarRespostasDinamicas(this.viewModel.id);
          } else {
            this.$router.go(-1);
          }
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    SaveNew() {
      this.loading = true;
      InventoryService.New(this.viewModel)
        .then((resposta) => {
          this.loading = false;
          this.$notify({
            data: ["Inventário cadastrado com sucesso."],
            type: "success",
            duration: 5000
          });
          if (this.dynamicAnswers.length > 0) {
            const inventoryId =
              typeof resposta.data === "string"
                ? resposta.data
                : resposta.data && resposta.data.id;
            if (inventoryId) {
              this.SalvarRespostasDinamicas(inventoryId);
              return;
            }
          }
          this.$router.go(-1);
        })
        .catch((erro) => {
          this.loading = false;
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },

    ValidateCoordenate() {
      return !this.viewModel.latitude && !this.viewModel.longitude;
    },
    Save() {
      this.viewModel.projectId = this.project.id;

      if (this.ValidateCoordenate()) {
        this.$notify({
          data: ["Informe latitude e longitude no mapa."],
          type: "warn",
          duration: 5000
        });
        return;
      }

      if (this.files) {
        this.UploadFiles();
      } else if (this.isEdit) {
        this.SaveEdit();
      } else {
        this.SaveNew();
      }
    },
    SetLocation(latitude, longitude) {
      this.viewModel.latitude = latitude;
      this.viewModel.longitude = longitude;
    },
    GetDynamicQuestions() {
      DynamicFormService.ObterTodas(false)
        .then((resposta) => {
          this.dynamicAnswers = resposta.data.map((q) => ({
            dynamicQuestionId: q.id,
            questionTitle: q.title,
            questionType: q.questionType,
            isRequired: q.isRequired,
            order: q.order,
            textValue: null,
            options: q.options || [],
            selectedOptionIds: [],
            _selectedSingle: null
          }));
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    GetDynamicAnswers(inventoryId) {
      DynamicFormService.ObterRespostasPorInventario(inventoryId)
        .then((resposta) => {
          this.dynamicAnswers = resposta.data.map((r) => ({
            ...r,
            _selectedSingle:
              r.selectedOptionIds && r.selectedOptionIds.length > 0
                ? r.selectedOptionIds[0]
                : null
          }));
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    },
    SalvarRespostasDinamicas(inventoryId) {
      const TIPOS_OPCAO = [
        QuestionTypeEnum.SingleChoice,
        QuestionTypeEnum.MultipleChoice,
        QuestionTypeEnum.Dropdown
      ];
      const answers = this.dynamicAnswers.map((r) => {
        if (TIPOS_OPCAO.includes(r.questionType)) {
          return {
            dynamicQuestionId: r.dynamicQuestionId,
            textValue: null,
            selectedOptionIds:
              r.questionType === QuestionTypeEnum.MultipleChoice
                ? r.selectedOptionIds
                : r._selectedSingle
                ? [r._selectedSingle]
                : []
          };
        }
        return {
          dynamicQuestionId: r.dynamicQuestionId,
          textValue: r.textValue,
          selectedOptionIds: null
        };
      });

      DynamicFormService.SalvarRespostas({
        gaauId: null,
        inventoryId,
        answers
      })
        .then(() => {
          this.$router.go(-1);
        })
        .catch((erro) => {
          this.$notify({
            data: erro.response.data.erros,
            type: "warn",
            duration: 5000
          });
        });
    }
  }
};
</script>
